import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { ApiProvider } from '../../../providers/api/api';
import { HelpersProvider } from '../../../providers/helpers/helpers';
import { AuthService } from '../../../providers/auth/auth.service';
import { CustomerProvider } from '../../../providers/customer/customer';
import { UserProvider } from '../../../providers/user/user';
import { I18nProvider } from '../../../providers/i18n/i18n';


@Component({
  selector: 'component-customer-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class CustomerHistoryComponent implements OnChanges {
  protected headers: any;
  @Input() studentData: any = null;

  @Output() closeHistory = new EventEmitter<void>();
  search = '';
  loadError = false;
  weekTrainings = 0;
  private requestVersion = 0;

  get filteredHistory(): any[] {
    const term = this.helpers.removeDiacritics(this.search.trim().toLowerCase());
    return (this.history || []).filter(program => {
      const names = [this.helpers.returnTranslation(program)]
        .concat(this.completedTrainings(program).map(training => this.helpers.returnTranslation(training))).join(' ');
      return !term || this.helpers.removeDiacritics(names.toLowerCase()).includes(term);
    });
  }

  completedTrainings(program: any): any[] {
    return (program.trainings || []).filter(training => Number(training.done) === 1 || Number(training.done) === 2)
      .slice().sort((a, b) => this.completionDate(b).localeCompare(this.completionDate(a)));
  }

  completionDate(item: any): string {
    const value = item.done_date && (item.done_date.date || item.done_date);
    const day = typeof value === 'string' ? value.slice(0, 10) : '';
    return /^\d{4}-\d{2}-\d{2}$/.test(day) && !isNaN(Date.parse(day)) ? day : '';
  }

  currentWeek() {
    this.wPage = 0;
    this.returnStatusDay(0, this.history);
  }

  loading: boolean = false;
  history = [];

  mcalendar: any = [];
  donePrograms: number = 0;
  doneTrainings: number = 0;
  wPage: number = 0;
  dateRangeText: string = '';
  dateRangeYear: string = '';

  PAGE: any;
  STRINGS: any;

  constructor(
    public toastr: ToastrService,
    public auth: AuthService,
    public api: ApiProvider,
    public helpers: HelpersProvider,
    public dialog: MatDialog,
    public studentProv: CustomerProvider,
    public userProv: UserProvider,
    public i18n: I18nProvider,
  ) {
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('CustomerHistoryComponent');

    this.headers = {'Authorization': `Bearer ${localStorage.getItem('LoggedInUser')}`};

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.studentData) {
      this.search = '';
      this.wPage = 0;
      this.getHistory(this.studentData && this.studentData.id);
    }
  }

  async getHistory(id: any = 0) {
    const version = ++this.requestVersion;
    this.history = [];
    this.loadError = false;
    this.returnStatusDay(this.wPage, []);
    if (!id) { this.loading = false; return; }
    this.loading = true;
    try {
      const res: any = await this.studentProv.getHistory(id);
      if (version !== this.requestVersion) return;
      this.history = res.history || [];
      this.returnStatusDay(this.wPage, this.history);
    } catch (error) {
      if (version !== this.requestVersion) return;
      this.loadError = true;
      this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
    } finally {
      if (version === this.requestVersion) this.loading = false;
    }
  }

  toggleClass(item: any) {
    item.active = !item.active;
  }

  changeWPage(n: number = 0) {
    this.wPage = this.wPage + n;
    this.returnStatusDay(this.wPage, this.history);
  }

  returnStatusDay(w: number = 0, history: any = []) {
    const weekDates = this.helpers.getWeekDates(w);
    const today = this.returnWeekDay();
    const labels = [this.STRINGS.fdomingo, this.STRINGS.fsegunda, this.STRINGS.fterca,
      this.STRINGS.fquarta, this.STRINGS.fquinta, this.STRINGS.fsexta, this.STRINGS.fsabado];
    this.mcalendar = weekDates.map((date, day) => ({
      day, date, number: Number(date.slice(8, 10)), name: labels[day].slice(0, 3),
      status: w < 0 || (w === 0 && day < today) ? 'null' : 'todo'
    }));
    const firstYear = weekDates[0].slice(0, 4);
    const lastYear = weekDates[6].slice(0, 4);
    this.dateRangeYear = firstYear === lastYear ? firstYear : firstYear + ' - ' + lastYear;
    this.dateRangeText = this.helpers.getMonthDay(weekDates[0]) + ' - ' + this.helpers.getMonthDay(weekDates[6]);
    this.donePrograms = 0;
    this.doneTrainings = 0;
    this.weekTrainings = 0;
    (history || []).forEach(program => {
      if (Number(program.done) === 1) this.donePrograms++;
      this.completedTrainings(program).forEach(training => {
        this.doneTrainings++;
        const day = this.mcalendar.find(item => item.date === this.completionDate(training));
        if (day) { day.status = 'done'; this.weekTrainings++; }
      });
    });
    return 'todo';
  }

  returnWeekDay() {
    const d = new Date();
    let day = d.getDay();
    if (this.wPage !== 0) day = -1;
    return day;
  }
  

}
